import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { PlanningAggregationOptionEnum } from '../../models/enum/planning-aggregation-option.enum';
import { PlanningGenerationType } from '../../models/enum/planning-generation-type.enum';
import { PlanningOverrideOption } from '../../models/enum/planning-override-option.enum';
import { SourcePriceOptionEnum } from '../../models/enum/source-price-option.enum';

@Component({
    templateUrl: './generate-planning-dialog.component.html',
    styleUrls: [ './generate-planning-dialog.component.scss' ],
})
export class GeneratePlanningDialogComponent {


    public aggregationOption = PlanningAggregationOptionEnum;
    public overrideOption = PlanningOverrideOption;
    public planningGenerationType = PlanningGenerationType;
    public sourcePriceOption = SourcePriceOptionEnum;

    public formGroup = this.myFormBuilder.group({
        sourceDaterange: this.myFormBuilder.group({
            from: [ null as moment.Moment, Validators.required ],
            to: [ null as moment.Moment, Validators.required ],
        }),
        sourcePrices: [ SourcePriceOptionEnum.PURCHASE_PRICE, Validators.required ],
        targetDaterange: this.myFormBuilder.group({
            from: [ null as moment.Moment, Validators.required ],
            to: [ null as moment.Moment, Validators.required ],
        }),
        aggregationOption: [ PlanningAggregationOptionEnum.AVERAGE, Validators.required ],
        overrideOption: [ PlanningOverrideOption.REPLACE, Validators.required ],
    });

    constructor(@Inject(MAT_DIALOG_DATA) public data: PlanningGenerationType,
                private myMatDialogRef: MatDialogRef<GeneratePlanningDialogComponent>,
                private myFormBuilder: FormBuilder) {
        if (this.data === PlanningGenerationType.SALES_VOLUME) {
            // Disable so that the values are undefined instead of being hidden but set.
            this.formGroup.controls.aggregationOption.disable();
            this.formGroup.controls.sourcePrices.disable();
        }
    }


    public close(): void {
        this.myMatDialogRef.close();
    }

    public save(): void {
        this.myMatDialogRef.close(this.formGroup.value);
    }
}
